import { motion } from "framer-motion"

import TechnologyHero from '../../molecules/TechnologyHero/TechnologyHero'
import TechnologySteps from '../../molecules/TechnologySteps/TechnologySteps'
import ApproachSection from '../../molecules/ApproachSection/ApproachSection'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'
import commonfooter from '../../../assets/images/commonfooter.webp'

const TechnologyPage = () => {
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: "-100px" },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  }

  return (
    <div className="w-full overflow-x-hidden"> {/* ✅ FIX */}
      <main
        className="relative min-h-screen text-white"
        style={{ backgroundColor: colors.deepNavy }}
      >
        <div className="relative z-10 overflow-hidden"> {/* ✅ EXTRA SAFETY */}

          <TechnologyHero />
          <motion.div {...fadeUp}><TechnologySteps /></motion.div>
          <motion.div {...fadeUp}><ApproachSection /></motion.div>
          <motion.div {...fadeUp}>
          <CommanFooterCard
 paragraph="We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events."
imageSrc={commonfooter}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #874bff7d 17.11%, rgba(135, 75, 255, 0) 100%)"
/>
          </motion.div>
          <motion.div {...fadeUp}><Testimonial className="mx-auto mb-20 max-w-[90%]"/></motion.div>

          <motion.div {...fadeUp}>
            <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
              <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
                <Message />
                <Questions />
              </div>
            </div>
          </motion.div>

          <Footer />

        </div>
      </main>
    </div>
  )
}

export default TechnologyPage
